export const SET_CURRENT_DIRECTORY = 'SET_CURRENT_DIRECTORY'
export const SET_CURRENT_TEXTURE = 'SET_CURRENT_TEXTURE'
export const SET_CURRENT_WORKSPACE = 'SET_CURRENT_WORKSPACE'
export const INSERT_DATA = 'INSERT_DATA'
export const ADD_WORKSPACE = 'ADD_WORKSPACE'
export const DELETE_WORKSPACE = 'DELETE_WORKSPACE'
export const START_UPDATE_ITEM_BLOB = 'START_UPDATE_ITEM_BLOB'
export const UPDATE_ITEM_BLOB = 'UPDATE_ITEM_BLOB'
export const END_UPDATE_ITEM_BLOB = 'END_UPDATE_ITEM_BLOB'
export const CLEAR_ITEM_BLOBS = 'CLEAR_ITEM_BLOBS'
export const FILE_SAVED = 'FILE_SAVED'
export const SET_PROFILE = 'SET_PROFILE'



// WEBPACK FOOTER //
// ./app/constants/workspace.js